/**
 * @desc 取消供应商认证
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierPushPoRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierAccount/changePushPo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
